export default __webpack_public_path__ + "static/media/badge-google-play.e0cdcafc.png";